import { Button } from '@mui/material';
import { BaseButtonProps } from './BaseButton.types';

/**
 * A customizable button component that wraps the MUI Button component.
 *
 * @param id - {@link BaseButtonProps.id id} description.
 * @param title - {@link BaseButtonProps.title title} description.
 * @param ariaLabel - {@link BaseButtonProps.ariaLabel ariaLabel} description.
 * @param className - {@link BaseButtonProps.className className} description.
 * @param variant - {@link BaseButtonProps.variant variant} description.
 * @param disabled - {@link BaseButtonProps.disabled disabled} description.
 * @param onClick - {@link BaseButtonProps.onClick onClick} description.
 * @param children - {@link BaseButtonProps.children children} description.
 */
export const BaseButton = ({
    id,
    title,
    ariaLabel,
    className,
    variant,
    disabled,
    onClick,
    children,
}: BaseButtonProps) => {
    return (
        <Button
            id={id}
            title={title}
            aria-label={ariaLabel}
            className={className}
            variant={variant}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};